import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderFr = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <HighlightedText
            text="FAITES TOURNER LA ROUE ET RECEVEZ DES TOURS GRATUITS"
            highlights={
                isDesktop
                    ? [{ word: 'DES' }, { word: 'TOURS' }, { word: 'GRATUITS' }]
                    : [{ word: 'TOURS' }, { word: 'GRATUITS' }]
            }
            breakAfterWords={isDesktop ? ['RECEVEZ'] : ['TOURNER', 'DES']}
            className={common.text_header}
        />
    )
}

export const TextLandFr = () => {
    return (
        <HighlightedText
            text="VOUS AVEZ GAGNÉ 400 TOURS RATUITS"
            highlights={[
                { word: '400' },
                { word: 'TOURS' },
                { word: 'RATUITS' },
            ]}
            breakAfterWords={['GAGNÉ']}
            className={styles.text_content}
        />
    )
}
